import React from 'react';
import { Route, Link, withRouter } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import MaterialTable from 'material-table'
import './lecture.css'
import { List, ListItem, ListItemText } from '@material-ui/core';
import {SingleTestView} from './singletestview'
import { Tabs } from '@material-ui/core';
import { Tab } from '@material-ui/core';
import {TestStatistics} from './teststatistics'
import SwipeableViews from 'react-swipeable-views';

const isEqual = require("react-fast-compare")


class Stats extends React.Component {
  constructor(props){
    super(props)
    this.state = {
        lecture : {},
        tests : [],
        filtered_tests : [],
        singletestview : false,
        tab : 0,
    }
  }

  addTry = (user) => {
      let s = this.props.socket
      s.emit('add usertry',{'id':this.state.id,'user':user})
  }

  showSingleTest = (tid,tnr) => {
    let s = this.props.socket
    s.emit('get single test view',{tid:tid,tnr:tnr}, data => {this.setState({singletestview:data})})
    console.log(tid,tnr)
  }



  // cellStyle : rowData => ({backgroundColor: (rowData.passed) ? '#00800061' : '#ff000069'}),

  columns =  [
    {title : 'Mitarbeiter', field : 'user',
    render : rowData => {return (<span>{rowData.user} </span>) } },
    {title : 'Qualifikation', field : 'qualification',
    render : rowData => {return (<span>{rowData.qualification} </span>) } },
    {title : 'Versuche', field : 'tests',
    render : rowData => {return (<span>{rowData.tests.length} </span>) } },
    {title : 'bestanden', field : 'passed',
    render : rowData => {return (<span ClassName={(rowData.passed) ? 'greenrow':'redrow'}>{rowData.passed? 'JA' : rowData.tests.length ? 'Nein': '---'} </span>) } },
    {title: 'Datum' ,field: 'last_passed_result',
    render : rowData => {return (<span>{rowData.last_passed_result || ''}</span>)},
    customSort: (a, b) => {
      if (!a.last_passed_result || !b.last_passed_result) return true;
      const dateA = new Date(
        a.last_passed_result.split(".").reverse().join("-")
      );
      const dateB = new Date(
        b.last_passed_result.split(".").reverse().join("-")
      );
      return dateA - dateB;
    },
    },
    {title : 'Versuche übrig', field : 'triesleft',
    render : rowData => {return (<span>{rowData.triesleft} <Button variant="outlined" onClick={e=> this.addTry(rowData.user)}>hinzufügen</Button> </span>) } },

  ]

  options= {
    pageSize : 10,
      rowStyle: rowData => ({
        backgroundColor: (rowData.passed) ? '#00800020' : rowData.tests.length ? '#e5ff0020': '#ff000020'
      })
  }



  detailPanel =  [
    {
      tooltip: 'Tests',
      render: rowData => {
        return (
          <List>
            {rowData.tests && rowData.tests.map((test,i) => 
            <Paper>
              <ListItem className={test.passed ? 'greenrow': 'redrow'} onClick={e => this.showSingleTest(rowData.tid,i)}>
                <ListItemText primary={test.start} secondary={'Punkte: '+test.points+'\n'+'Dauer: '+test.duration}/>
              </ListItem>
            </Paper>
            )}
          </List>
        )
      },
    },
    ]

  componentDidMount (){
    const {params} = this.props.match ? this.props.match : false
    if (params && 'id' in params) this.setState({id : params.id})
    let s = this.props.socket
    s.on('test results', data => {
      this.setState({tests : data.tests,lecture:data.lecture})

    })
    s.emit('get statistics',{id : params.id})
  }

  handleTabChange = (event,tab) => {
    this.setState({ tab });
  }



  render () {
    const { tests,lecture,singletestview} = this.state
    return (
      <div>
        <Typography variant="headline" gutterBottom className='headline'>{'Statistik für ' + lecture.name + ' (V:'+lecture.version+')'}</Typography>
        <Tabs fullWidth value={this.state.tab}onChange={this.handleTabChange}>
            <Tab label="Mitarbeiter" id={0}/>
            <Tab label="Fragen" id={1}/>
        </Tabs>
        <SwipeableViews index={this.state.tab} >
        <div style={{width:'100vw'}}>
        {lecture?.id ? <MaterialTable style={{width:'100vw'}} columns={this.columns} options={this.options} data={tests} detailPanel={this.detailPanel} title="Testergebnisse"/> : <>leer</>}
        </div>
        <div>
          <TestStatistics socket={this.props.socket} id={lecture.id}/>
        </div>
        </SwipeableViews>
        <SingleTestView {...singletestview} onclose={e => this.setState({singletestview:false})}/>
      </div>
    )
  }


}

export default withRouter(Stats)
